
import Vue from "vue";
import Component from "vue-class-component";

import { State } from "vuex-class";
import { TracerStudy } from "@/store/tracerstudy/types";

import RespondentResult from "./RespondentResult.vue";
import RespondentQuestion from "./RespondentQuestion.vue";

@Component({
  components: {
    RespondentResult,
    RespondentQuestion,
  },
})
export default class Respondent extends Vue {
  /* VUEX */

  /* STATE */
  @State("tracerStudy", { namespace: "tracerstudy" })
  private tracerStudy: TracerStudy;

  /* INITIALIZATION */
  private activeTab: number = 0;
}
